export const isEventTargetANode = (
  target: EventTarget | null
): target is Node => !!target && "nodeType" in target;
